<template>
  <div>
    <LocalizationForm />
  </div>
</template>
<script>
import LocalizationForm from "./Localization/LocalizationForm.vue";
export default {
  components: {
    LocalizationForm,
  },
};
</script>
